class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.showOnlyFirstFilter();
    this.bindFilterEvents();
  }

  showOnlyFirstFilter() {
    const allAccordions = this.querySelectorAll("custom-accordion");
    allAccordions.forEach((accordion, index) => {
      accordion.style.display = index === 0 ? "block" : "none";
      accordion.setAttribute("open", index === 0 ? "true" : "false");
    });
  }

  bindFilterEvents() {
    const form = this.querySelector("form");
    if (!form) return;

    form.addEventListener("change", (event) => {
      const currentAccordion = event.target.closest("custom-accordion");
      const allAccordions = Array.from(
        this.querySelectorAll("custom-accordion")
      );
      const currentIndex = allAccordions.indexOf(currentAccordion);

      // Show all up to current + 1
      allAccordions.forEach((acc, i) => {
        acc.style.display = i <= currentIndex + 1 ? "block" : "none";
        acc.removeAttribute("open");
      });

      // Open the next one
      const nextAccordion = allAccordions[currentIndex + 1];
      if (nextAccordion) {
        nextAccordion.setAttribute("open", "true");
      }

      this.renderPage();
    });
  }

  renderPage() {
    const form = this.querySelector("form");
    if (!form) return;

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;
    const sections = this.getSections();

    window.history.pushState({}, "", url);

    sections.forEach((section) => {
      const sectionUrl = `${url}&section_id=${section.section}`;
      fetch(sectionUrl)
        .then((res) => res.text())
        .then((html) => {
          this.renderSection(html, section);
        });
    });
  }

  renderSection(html, section) {
    const newDom = new DOMParser().parseFromString(html, "text/html");

    // Product grid update
    const productGrid = document.querySelector(
      `#ProductGridContainer-${section.section}`
    );
    const newProductGrid = newDom.querySelector(
      `#ProductGridContainer-${section.section}`
    );
    if (productGrid && newProductGrid) {
      productGrid.innerHTML = newProductGrid.innerHTML;
    }

    // Filters update
    const newFacet = newDom.querySelector(
      `#FacetFiltersForm-${section.section}`
    );
    const facetContainer = document.querySelector(
      `#FacetFiltersForm-${section.section}`
    );
    if (newFacet && facetContainer) {
      facetContainer.innerHTML = newFacet.innerHTML;

      // Rebind JS after reload
      const newForm = facetContainer.querySelector("facet-filters-form");
      if (newForm && typeof newForm.init === "function") {
        newForm.init();
      }
    }
  }

  getSections() {
    return [{ section: "main-collection-product-grid" }];
  }
}

customElements.define("facet-filters-form", FacetFiltersForm);
